/** 控制台 · API Key 页（pages/console/keys.tsx）。 */
const messages = {
  'page.title': 'API Key',
  'page.description': '用 <auth/> 调用 <base/>。点列表里的 Key 可以随时复制完整密钥。',
  'page.create': '新建 Key',

  'validation.money': '请输入金额，最多 6 位小数',
  'validation.moneyPositive': '金额必须大于 0',
  'validation.optionalMoney': '请输入大于 0 的金额，或留空',
  'validation.optionalInt': '请输入正整数，或留空',
  'validation.nameRequired': '请填写名称',
  'validation.nameMax': '最多 64 个字符',
  'validation.scopesMin': '至少选择一项权限',
  'validation.modelsRequired': '有“{scope}”权限时，至少选择一个模型',
  'validation.dailyOverTotal': '日上限不能超过累计上限',
  'validation.expiryRequired': '请选择到期日期',
  'validation.expiryFuture': '到期日期需晚于今天',

  'expiry.never': '永不过期',
  'expiry.30': '30 天',
  'expiry.90': '90 天',
  'expiry.365': '1 年',
  'expiry.custom': '指定日期',

  'step.aria': '创建步骤',
  'step.basic': '基本信息',
  'step.scopes': '权限',
  'step.limits': '限额',
  'step.expiry': '有效期',

  'created.title': '保存你的 API Key',
  'created.description': '完整密钥只显示这一次。关闭后平台也无法再次查看，遗失只能撤销后重建。',
  'created.serverOnly.title': '只在服务端使用',
  'created.serverOnly.body': '通过环境变量注入，不要写进前端代码、移动端安装包或公开仓库。',
  'created.savedConfirm': '我已把密钥保存在安全的地方',
  'created.done': '完成',

  'create.title': '新建 API Key',
  'create.description': '每个应用或环境单独一把 Key，方便独立限额与撤销。',
  'create.name.placeholder': '例如：生产环境-剪辑服务',
  'create.name.description': '只用于你自己区分，最多 64 个字符。',
  'create.models.legend': '模型白名单',
  'create.models.description': '只列出账号已获授权的模型。之后新上架的模型不会自动加入这把 Key。',
  'create.models.loadError': '模型列表加载失败',
  'create.models.none.title': '账号还没有获得任何模型授权',
  'create.models.none.body': '联系运营开通后再为 Key 选择模型。没有模型时，Key 只能管理素材。',
  'create.total.label': '累计上限（必填）',
  'create.total.description': '已结算 + 冻结中的金额达到上限后，新任务返回 402 key_limit_exceeded。',
  'create.daily.description': '按 Asia/Shanghai 日界线（每天 00:00）重置。留空表示不限。',
  'create.rpm.label': '每分钟请求数（可选）',
  'create.concurrency.label': '并发任务数（可选）',
  'create.date.label': '到期日期',
  'create.date.description': '当天 23:59（Asia/Shanghai）后失效。',
  'create.error': '创建失败',
  'create.back': '上一步',
  'create.next': '下一步',
  'create.submit': '创建 Key',

  'list.maskedHint': '这把 Key 创建得较早，没有保存完整密钥，无法复制；请新建一把 Key',
  'copy.done': '密钥已复制',
  'copy.failed': '复制失败，请手动选中密钥复制',
  'copy.again': '已复制，可再次复制',
  'copy.button': '复制密钥',

  'edit.title': '编辑 Key',
  'edit.description': '<key/> · 修改立即生效',
  'edit.saved': '已保存',
  'edit.error': '保存失败',
  'edit.daily.description': '按 Asia/Shanghai 日界线重置，留空表示不限。',

  'field.name': '名称',
  'field.status': '状态',
  'field.scopes': '权限',
  'field.models': '模型',
  'field.total': '累计上限',
  'field.daily': '日上限',
  'field.dailyOptional': '日上限（可选）',
  'field.expiry': '有效期',
  'field.lastUsed': '最近使用',
  'field.usage': '累计额度（已用 / 上限）',
  'field.actions': '操作',
  unlimited: '不限',
  cancel: '取消',
  save: '保存',

  'action.failed': '操作失败',
  'action.disable.title': '停用这把 Key？',
  'action.disable.body1': '使用该 Key 的请求会立即收到 401 invalid_api_key。',
  'action.disable.body2': '已提交的任务继续处理，历史任务与账单保留。',
  'action.disable.body3': '之后可以随时重新启用。',
  'action.disable.confirm': '停用',
  'action.disable.done': '已停用',
  'action.enable.title': '重新启用这把 Key？',
  'action.enable.body1': '启用后立即可以用它调用 API，限额与权限保持不变。',
  'action.enable.confirm': '启用',
  'action.enable.done': '已启用',
  'action.revoke.title': '撤销这把 Key？此操作不可恢复',
  'action.revoke.body1': '使用该 Key 的应用会立即收到 401，且无法再启用。',
  'action.revoke.body2': '已提交的任务继续处理，历史任务与账单仍保留。',
  'action.revoke.body3': '如需继续调用，请新建一把 Key 并替换到应用中。',
  'action.revoke.confirm': '撤销 Key',
  'action.revoke.done': '已撤销',

  'usage.aria': '累计额度已用 {pct}%',
  'menu.aria': '{name} 的操作',
  'menu.edit': '编辑名称与限额',
  'menu.disable': '停用',
  'menu.enable': '启用',
  'menu.revoke': '撤销',
  'models.none': '未选择',

  'example.comment': '在服务端提交一个文生视频任务（Key 不要放进前端或 App）',
  'example.title': '在服务端调用',
  'example.description': '把 {prefix} 这类 Key 放进环境变量 AITOKEN_API_KEY，再这样提交任务。',
  'example.returns.label': '返回',
  'example.returns.body': '202 与任务 ID，之后轮询 {path} 或等 Webhook',
  'example.scopes.label': '权限',
  'example.scopes.body': '提交需要「{create}」，查询需要「{read}」；不需要的权限不要勾',
  'example.quota.label': '额度',
  'example.quota.body': '提交时按上界冻结，Key 的累计上限与日上限同时生效',
  'example.leak.label': '泄露',
  'example.leak.body': '立即在上方停用或撤销；撤销不可恢复，已提交的任务照常完成',

  'list.loadError': 'Key 列表加载失败',
  'list.docsLink': '权限与限额说明',
  'list.count': '共 {total} 把 Key，{active} 把启用中',
  'empty.learn': '了解权限与限额',
  'empty.body': '还没有 API Key。创建第一把 Key，设定可用模型与累计上限，然后在服务端调用 API。',
};

export default messages;
